import axios from 'axios';

export const billingService = {
    list
};

function list(month) {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/billing/"+(typeof month!== "undefined" ? month:""), {params: {}});
}